import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../context/AuthProvider";
import { map } from "lodash";
import { fetchWithInterceptor } from "../utils/fetchWithInterceptor";

export default function useSizes(refresh) {
  const authContext = useContext(AuthContext);

  const [sizes, setSizes] = useState([]);

  const getSizes = async () => {
    const response = await fetchWithInterceptor(
      `/api/integrations/liquor-connect/sizes`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": authContext.getToken(),
        },
      }
    );
    if (response.ok) {
      const data = await response.json();
      setSizes(map(data, (size) => ({ label: size.name, value: size.name })));
    }
  };

  useEffect(() => {
    getSizes();
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh])

  return sizes;
}